<template lang="pug">
  form.stage-form(@submit.prevent="onSubmit")
    BaseField.input(v-model="form.name.value" v-bind="form.name" ref="input" @change="onInputChange('name')")
    Btn(submit green) Сохранить
    Btn(@click="cancel" grey) Отмена
</template>

<script>
import model from '@/model/stage';
import form from '@/utils/form';

import BaseField from '@/components/BaseField.vue';

export default {
  name: 'StageForm',
  components: { BaseField },
  props: {
    stage: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.form.name.value = this.stage.name;
    this.$nextTick(() => { this.$refs.input.focus(); });
  },
  data() {
    return {
      form: {
        name: form.createFieldObject('text', 'Название раздела', '', { required: 'Укажите название раздела' }),
      },
    };
  },
  methods: {
    onInputChange(fieldName) {
      form.validateField(this.form, fieldName);
    },
    onSubmit() {
      form.validate(this.form);

      if (form.hasErrors(this.form)) return;

      model.saveInList({ ...this.stage, name: this.form.name.value });
    },
    cancel() {
      model.cancelEdit();
    },
  },
};
</script>

<style scoped>
.stage-form {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-grow: 1;
}

.input {
   flex-grow: 1;
 }

@media(max-width: 576px) {
  .stage-form {
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .input {
    width: 100%;
  }
}
</style>
